const createInitialCanvasHistoryState = () => ({
  stack: [],
  index: -1,
})

export const historyReducer = (state, action) => {
  const { activeCanvas } = action
  const canvasState = state.canvases ? state.canvases[activeCanvas] : null
  const maxEntries = 100

  switch (action.type) {
    case 'PUSH': {
      const { newState } = action
      // Drop off later entries if index is not at the top of the stack to prevent
      // redoing actions that no longer follow the current one.
      const nextStack = state.canvases[activeCanvas].stack
        .slice(0, canvasState.index + 1)
        .concat([newState])

      if (nextStack.length > maxEntries) nextStack.shift()

      return {
        ...state,
        canvases: {
          ...state.canvases,
          [activeCanvas]: {
            ...canvasState,
            stack: nextStack,
            index: nextStack.length - 1,
          },
        },
      }
    }
    case 'SAVE':
      var { key } = action
      var nextState = { ...state, key }
      // TODO: Pull this out of reducer.
      localStorage.setItem('cover-history', JSON.stringify(nextState))

      return nextState
    case 'UNDO':
      return {
        ...state,
        canvases: {
          ...state.canvases,
          [activeCanvas]: {
            ...canvasState,
            index: Math.max(0, canvasState.index - 1),
          },
        },
      }
    case 'REDO':
      return {
        ...state,
        canvases: {
          ...state.canvases,
          [activeCanvas]: {
            ...canvasState,
            index: Math.min(
              canvasState.stack.length - 1,
              canvasState.index + 1,
            ),
          },
        },
      }
    case 'RESET':
      if (action.initialState) {
        return { ...action.initialState }
      } else {
        return {
          key: '',
          canvases: {
            front: createInitialCanvasHistoryState(),
            back: createInitialCanvasHistoryState(),
            spine: createInitialCanvasHistoryState(),
          },
        }
      }
    default:
      return state
  }
}
